import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BsDatepickerModule,
  TooltipModule,
  AccordionModule,
  TabsModule,
  BsDropdownModule,
  ProgressbarModule,
  TimepickerModule,
  ModalModule } from 'ngx-bootstrap';

  import { NouisliderModule } from 'ng2-nouislider';


@NgModule({
  imports: [
    CommonModule,
    BsDatepickerModule.forRoot(),
    TooltipModule.forRoot(),
    AccordionModule.forRoot(),
    BsDropdownModule.forRoot(),
    ProgressbarModule.forRoot(),
    TabsModule.forRoot(),
    TimepickerModule.forRoot(),
    ModalModule.forRoot(),
    NouisliderModule
  ],
  exports: [
    BsDatepickerModule,
    TooltipModule,
    AccordionModule,
    BsDropdownModule,
    ProgressbarModule,
    TabsModule,
    TimepickerModule,
    NouisliderModule
  ]
})
export class NgxBootstrapModule { }



// WEBPACK FOOTER //
// ./src/app/ngx-bootstrap/ngx-bootstrap.module.ts